/* import __COLOCATED_TEMPLATE__ from './backdrop.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./backdrop.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());